module.exports = __webpack_public_path__ + "assets/f88fa42dfa82d55c173b2c0e07d045e6.png";